// ----------------------------------------------------------------------
// <copyright file='Izenda.ExportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');

  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  var Button = require('./Izenda.Button');

  var action = require('./Izenda.ExportButtonAction');

  const { map } = require('lodash/fp');

  var ExportButton = React.createClass({
    componentDidMount: function() {
      var $ul = $izenda(ReactDOM.findDOMNode(this.refs.menu));
      var $button = $izenda(ReactDOM.findDOMNode(this.refs.button));
      var $group = $izenda(ReactDOM.findDOMNode(this.refs.group));

      $button.click(function() {
        var ulOffset = $ul.offset();
        var spaceUp = ulOffset.top - $button.height() - $ul.height() - $izenda(window).scrollTop();
        var spaceDown = $izenda(window).scrollTop() + $izenda(window).height() - (ulOffset.top + $ul.height());

        if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown)) {
          $group.addClass('dropup');
        } else {
          $group.removeClass('dropup');
        }
      });
    },

    render: function() {
      var props = this.props;
      var disabled = props.disabled;
      var exportFormatList = props.getExportFormats('');
      var localization = props.localization;
      var label = localization.getText('COMMON_LABEL_EXPORT');
      var exportFn = props.isDashboard ? props.exportDashboard : props.exportReport;
      return (
        exportFormatList.length > 0 && (
          <div ref="group" className="btn-group">
            <Button ref="button" label={label} className="dropdown-toggle" data-toggle="dropdown" disabled={disabled}>
              <span className="caret" />
            </Button>
            <ul ref="menu" className={classnames('dropdown-menu', { 'dropdown-menu-right': props.menuRight })}>
              {map(function(format) {
                return (
                  <li key={format.label}>
                    <a onClick={exportFn(format.value)}>{format.label}</a>
                  </li>
                );
              }, exportFormatList)}
            </ul>
          </div>
        )
      );
    }
  });

  module.exports = connect(action)(ExportButton);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.ExportButton.jsx